module.exports = __webpack_public_path__ + "img/64.897e73f5.jpg";